/**
 * file : MyPage/Note.jsx
 * 설명 : 마이 페이지 화면 -> 쪽지 함
 */

import $ from 'jquery';
import Info from "./Info";
import { Fnc } from "common/globals";
import React, { useState, useEffect } from "react";
import { Search, Update } from "components/Common/ApiCall"
import { Spinner, Paging } from "components/Common/Componentization";
import { useNavigate } from 'react-router-dom';

export default function Note() {
  document.title = "쪽지함";
  // 경로 지정 
  const navigate = useNavigate();
  // 데이터
  const [datas, setDatas] = useState();
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);
  // 조회 조건
  const [searchWhere, setSearchWhere] = useState({
    per_page: 5
  });
  // 조회 조건 할당
  const searchWherePut = (key, val) => { setSearchWhere(prevState => ({ ...prevState, [key]: val}))};
  // 조회
  useEffect(() => {
    Search('/note', setDatas, setDataLoading, searchWhere)
  }, [searchWhere])
  // Toggle 관련
	const toggle = (target) => {
		$(".view").not(target).removeClass("open").next(".fold").removeClass("open");
		$(target).toggleClass("open").next(".fold").toggleClass("open")
	}
  return(
    <>
      <Spinner show={dataLoading} />
      <div className="mypage_wrap">
        <div className="location">
          MY PAGE &nbsp; &gt; &nbsp; 나의 정보 &nbsp; &gt; &nbsp; 쪽지함
			  </div>
        <Info />
        <div className="mypage_content box_style1">
          <div className="tit"><h2>쪽지함</h2></div>
          <div className="tab_mu">
            <div className="tab box_style1">
              <ul>
                <li onClick={() => navigate("/myPage/tournamentRequest")}>
                  토너먼트 신청내역
                </li>
                <li onClick={() => navigate("/myPage/Message")}  className="active">
                  쪽지함
                </li>
                <li onClick={() => navigate("/myPage/inquery")}>
                  문의하기
                </li>
              </ul>
            </div>
          </div>
          <div className="table-container">
            <table className="fold-table table_style1">
              <thead>
                <tr>
                  <th>NO</th>
                  <th>제목</th>
                  <th>수신일</th>
                  <th>작성자</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {!Fnc.Empty(datas) && <>
                  {
                    datas.data.map((data, index) => (
                      <React.Fragment key = {index}>
                        <tr className="view" onClick={(e) => {
                          toggle(e.currentTarget);
                          data.check_yn === 'N' && Update('/note/read', 'patch', { 'idx': data.idx }, setDataLoading, false, () => {
                            setDatas((currentDatas) => ({
                              ...currentDatas,
                              data: datas.data.map(
                                (item) => item.idx === data.idx ? { ...item, check_yn: 'Y', check_yn_name: '확인' } : item
                              )
                            }));
                          })
                        }}>
                          <td className="nu">{datas.currIndex - index}</td>
                          <td className="align_l">{data.title}</td>
                          <td>{Fnc.FormatDate(data.created_at, true)}</td>
                          <td>관리자</td>
                          <td><span className={`${data.check_yn === 'Y' ? 'bg0' : 'bg1'} smallbox`}>{data.check_yn_name}</span></td>
                        </tr>
                        <tr className="fold">
                          <td colSpan="5">
                            <div className="fold-content align_l">
                          	  <div className="mb_20"><b>{data.title}</b></div>
                          	  <div>{data.content}</div>
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))
                  }
                </>}
              </tbody>
            </table>
            { Fnc.Empty(datas) && <div className='table-no-data'>쪽지 내역이 없어요</div> }
            <Paging pageData={datas} PageChange={searchWherePut} />
          </div>
        </div>
      </div>
    </>
  )
}